// export type AttributionStatus = 'Active' | 'Inactive';
export type AttributionStatus = 'ACTIVE' | 'INACTIVE';

export const ATTRIBUTION_TYPE_DEFAULT: string = 'PARTNER';

export interface AttributionBaseDB {
    id: string;
    attribution_guid: string;
    display_name: string;
    status: AttributionStatus;
    type: string;
    type_version:number;
    properties_version: number;
    properties: Record<string, any>;
}

export interface Attribution {
    attributionGuid: string;
    displayName: string;
    status: AttributionStatus;
    type: string;
    properties: Record<string, any>;
    typeVersion?: number;
    propertiesVersion?: number;
    schemaType?: string;
}



export type AttributionSummary = Omit<Attribution, 'properties'>;


export type OrganizationAttribution = {
    organizationGuid: string;
    attributionGuid: string;
    organizationAttributionGuid: string;
    required: boolean;
}

export type OrganizationAttributionDB = {
    id: string;
    organization_id: string;
    attribution_id: string;
    organization_attribution_guid: string;
    required: boolean;
}

export type OrganizationAttributionApi = {
    attribution_guid: string;
    display_name: string;
    organization_attribution_guid: string;
    required: boolean;
    status: string;
    type: string;
}

export type JsonSchemaTypeDefinitionProperty = {
    type?: string;
    format?: string;
    enum?: string[];
    default?: any;
    [label: string]: any;
  };
  
  export type JsonSchemaTypeDefinition = {
    $id?: string;
    $schema?: string;
    title: string;
    type: string;
    properties: Record<string, JsonSchemaTypeDefinitionProperty>;
    required?: string[];
    [label: string]: any;
  };
  
  export type JsonSchemaType = {
    schema_type: string;
    schema_type_version: number;
    latest?: boolean;
    schema: JsonSchemaTypeDefinition;
    displayName?: string;
    additionalProperties?: boolean;
    [label: string]: any;
  };
  

// this mirrors the backend joined call for getOrganizationAttributions
export interface OrganizationAttributionSummary extends AttributionSummary {
    organizationGuid: string;
    required: boolean;
    organizationAttributionGuid: string;
}

// "included" is a virtual field for the ui - not to be persisted directly
// - used to decide which specific service call to make: create, update or delete
export interface JoinedOrganizationAttributionSummary extends Omit<OrganizationAttributionSummary, 'organizationAttributionGuid'> {
    included: boolean;
    organizationAttributionGuid?: string;
}

export interface JoinedQuoteExperienceSummary {
    included: boolean;
    selectedQuoteExperienceGuid?: string;
    displayName: string
}

export interface AttributionVersion {
    schema_type: string;
    schema_type_version: number;
    schema_data_id: string;
    schema_data_version: number;
    latest: boolean;
    created_date: string;
    updated_date: string;
    data: Record<string, any>;
}

export interface AttributionVersionsResponse {
    total: number;
    versions?: AttributionVersion[];
    data?: AttributionVersion[];
}